import { Injectable } from '@angular/core';

import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isPlatform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class HapticServiceService {
  private isMobile: boolean;
  constructor() {
    this.isMobile = isPlatform('hybrid');

  }
  // convert below statement to function
  async hapticsImpact() {
    if (this.isMobile) {
      await Haptics.impact();
    }
  };
  async hapticsImpactMedium() {
    if (this.isMobile) {
      await Haptics.impact({ style: ImpactStyle.Medium });
    }
  };

  async hapticsImpactLight() {
    if (this.isMobile) {
      await Haptics.impact({ style: ImpactStyle.Light });
    }
  };

  async hapticsVibrate() {
    if (this.isMobile) {
      await Haptics.vibrate();
    }
  };

  async hapticsSelectionStart() {
    if (this.isMobile) {
      await Haptics.selectionStart();
    }
  };

  async hapticsSelectionChanged() {
    if (this.isMobile) {
      await Haptics.selectionChanged();
    }
  };

  async hapticsSelectionEnd() {
    await Haptics.selectionEnd();
  };
}



